import React from "react";
import styled from "styled-components";
import Crown from "images/homepage/Crown";

const Container = styled.section.attrs({
    className: "text-center",
})`
    margin-top: 130px;
`;

const Heading = styled.h1`
    margin-top: 5px;
    font-weight: 800;

    @media (min-width: 992px) {
        font-size: 56px;
    }
`;

const DescriptionContainerDesktop = styled.div.attrs({
    className: "container ps-3 pe-3",
})`
    display: none;

    @media (min-width: 992px) {
        font-size: 20px;
        display: block;
    }
`;

const DescriptionContainerMobile = styled.div.attrs({
    className: "container ps-3 pe-3",
})`
    font-size: 17px;

    @media (min-width: 992px) {
        display: none;
    }
`;

const HeadingText = styled.div.attrs({
    className: "container ps-3 pe-3",
})`
    font-size: 20px;
    font-weight: 400;
`;

const CardsContainer = styled.div.attrs({
    className: "container",
})`
    margin-top: 64px;
`;

const Card = styled.div`
    background: var(--color-bg-gray-light);
    border-radius: 24px;
    padding: 40px;
`;

const SubHeading = styled.h2`
    font-weight: 800;
    font-size: 24px;

    @media (min-width: 992px) {
        font-size: 37px;
    }
`;

const Point = styled.span`
    color: #1db954;
`;

interface WhyEntePoint {
    heading: string;
    image: JSX.Element;
    content: (JSX.Element | string)[];
}

interface WhyEnteProps {
    heading: string;
    descriptionDesktop: JSX.Element;
    descriptionMobile: JSX.Element;
    points: WhyEntePoint[];
}

export default function WhyEnte({
    heading,
    descriptionDesktop,
    descriptionMobile,
    points,
}: WhyEnteProps) {
    return (
        <Container>
            <Crown />
            <Heading>{heading}</Heading>
            <DescriptionContainerDesktop>
                {descriptionDesktop}
            </DescriptionContainerDesktop>
            <DescriptionContainerMobile>
                {descriptionMobile}
            </DescriptionContainerMobile>
            <CardsContainer>
                <div className="row">
                    {points.map((point, index) => (
                        <div
                            key={index}
                            className="col-lg-4 col-md-12 px-4 d-flex align-items-stretch"
                        >
                            <Card>
                                {point.image}
                                <SubHeading className="text-start">
                                    <Point>{`0${index + 1}`.slice(-2)}</Point>{" "}
                                    {point.heading}
                                </SubHeading>
                                {point.content.map((text, idx) => (
                                    <p key={idx} className="text-start">
                                        {text}
                                    </p>
                                ))}
                            </Card>
                        </div>
                    ))}
                </div>
            </CardsContainer>
        </Container>
    );
}
